import { Typography } from '@mui/material';
import { Chain } from '@ankr.com/chains-list';

import { ChainLogo } from 'modules/chains/components/ChainLogo';

import { useChainInfoStyles } from './useChainInfoStyles';

interface IChainInfoProps {
  chain: Chain;
}

export const ChainInfo = ({ chain }: IChainInfoProps) => {
  const { classes } = useChainInfoStyles();

  return (
    <div className={classes.root}>
      <ChainLogo chain={chain} size={32} />
      <div className={classes.info}>
        <Typography variant="subtitle2">{chain.name}</Typography>
        <Typography color="textSecondary" variant="body3">
          {chain.coinName.toUpperCase()}
        </Typography>
      </div>
    </div>
  );
};
